// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file reports/slow_moving_items_report.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { MovingItemsItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.SlowMovingItemsReportRequest
 */
export class SlowMovingItemsReportRequest extends Message<SlowMovingItemsReportRequest> {
  /**
   * Page number for pagination
   *
   * @generated from field: int32 page_number = 1;
   */
  pageNumber = 0;

  /**
   * Number of records per page
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<SlowMovingItemsReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SlowMovingItemsReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SlowMovingItemsReportRequest {
    return new SlowMovingItemsReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SlowMovingItemsReportRequest {
    return new SlowMovingItemsReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SlowMovingItemsReportRequest {
    return new SlowMovingItemsReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SlowMovingItemsReportRequest | PlainMessage<SlowMovingItemsReportRequest> | undefined, b: SlowMovingItemsReportRequest | PlainMessage<SlowMovingItemsReportRequest> | undefined): boolean {
    return proto3.util.equals(SlowMovingItemsReportRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SlowMovingItemsReportResponse
 */
export class SlowMovingItemsReportResponse extends Message<SlowMovingItemsReportResponse> {
  /**
   * List of slow moving items
   *
   * @generated from field: repeated com.neulink.pharmacy.MovingItemsItem slow_moving_items = 1;
   */
  slowMovingItems: MovingItemsItem[] = [];

  /**
   * Total number of items available
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<SlowMovingItemsReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SlowMovingItemsReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "slow_moving_items", kind: "message", T: MovingItemsItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SlowMovingItemsReportResponse {
    return new SlowMovingItemsReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SlowMovingItemsReportResponse {
    return new SlowMovingItemsReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SlowMovingItemsReportResponse {
    return new SlowMovingItemsReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SlowMovingItemsReportResponse | PlainMessage<SlowMovingItemsReportResponse> | undefined, b: SlowMovingItemsReportResponse | PlainMessage<SlowMovingItemsReportResponse> | undefined): boolean {
    return proto3.util.equals(SlowMovingItemsReportResponse, a, b);
  }
}

